<template>
    <div class="PageContent" :class="containerClass">
        <slot />
    </div>
</template>

<script>
    export default {
        name: 'PageContent',

        props: {
            width: {
                type: String,
                default: '800px',
            },
            minWidth: {
                type: String,
                default: 'unset',
            },
        },

        computed: {
            containerClass() {
                return {};
            },

            containerStyle() {
                return {
                    width: this.width,
                    minWidth: this.minWidth,
                };
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import "@/assets/scss/_variables.scss";
    
    .PageContent {
        margin-top: 120px;
        margin-bottom: 50px;
        box-sizing: content-box;
        margin-left: auto;
        margin-right: auto;
        padding: 0 40px;
    }

    @media only screen and (max-width: $phone-max-width) {
        .PageContent {
            margin-top: 105px;
        }
    }
</style>
